<script async setup>
import { useSEO } from '../../composables/seo'

definePageMeta({ scrollToTop: true })

const route = useRoute()
const { data, error } = await useFetch(
  `/api/champ?champ=${route.params.contestant}`,
  { key: route.params.contestant },
)

if (error.value) {
  // console.log('error is11', error.value)
  throw createError({ statusCode: 404 })
  // throw createError(...)
}

const { filteredShowList, contestantData, contestantDetails, user } = data.value
const { GenerateTags } = useSEO()

GenerateTags({
  title: `🤹 ${contestantDetails.name}`,
  desc: `${contestantDetails.name}'s show appearances on OTB's Crappy Quiz.`,
  // image: user.data.profile_image_url !== null ? user.data.profile_image_url : 'https://otb.ie/wp-content/uploads/2019/09/otb-logo.png'
})
</script>

<template>
  <div class="h-full pt-10">
    <div class="px-4 sm:pl-10 sticky sm:relative sm:top-0 top-5 z-50">
      <div
        class="flex items-center rounded-full backdrop-blur-[1.75px] sm:bg-transparent sm:dark:bg-gray-900 sm:rounded-none p-0"
      >
        <div v-if="contestantDetails?.twitter" class="flex">
          <div class="rounded-full p-0.3 ring-2 ring-green-400 mr-4">
            <NuxtImg
              class="w-16 h-16 rounded-full object-cover relative"
              :src="`/images/twitter-avatars/${contestantDetails.twitter}.jpg`"
              :alt="`Twitter photo of ${contestantDetails?.name}`"
            />
            <nuxt-link
              v-if="contestantDetails?.twitter"
              :href="`https://twitter.com/${contestantDetails?.twitter}`"
              class="p-1 rounded-md absolute top-0 left-12 animate-spin animate-duration-5s"
              rel="noopener"
              target="_blank"
              :aria-label="`${contestantDetails?.name}'s Twitter profile`"
            >
              <div class="i-logos-twitter text-lg sm:text-xl hover:scale-1100 duration-700" />
            </nuxt-link>
          </div>
        </div>
        <div
          class="text-2xl sg-bold dark:text-gray-50 champ"
        >
          {{ contestantDetails?.name }}
        </div>
      </div>
    </div>

    <div class="pl-4 sm:pl-10 pb-10">
      <div class="">
        <div class="flex items-center sg-regular pt-4 dark:text-gray-50">
          <div class="flex items-center w-full">
            <span v-if="filteredShowList?.length > 1">{{ filteredShowList?.length }} show appearances </span>
            <span v-else>{{ filteredShowList?.length }} show appearance </span>
            <span class="pl-1">
              <div class="i-mdi-arrow-down-right-bold text-xl text-blue-500 mt-5" /></span>
          </div>
          <span
            class="flex sm:hidden items-center py-1 justify-center rounded-md sg-regular border-1 border-gray-200 text-gray-500 dark:text-gray-200 bg-gray-50 dark:bg-gray-700 w-45 mr-2 dark:text-gray-700"
          >
            <div class="flex items-center">

              <div
                class="flex -rotate-20 items-center pl-2"
              >
                <div
                  class="i-fxemoji-trophy text-base animate-pulse animate-bounce-in-down -ml-1 -mt-2"
                />
                <div class="i-noto-v1-wavy-dash rotate-20 -mb-2 mr-2 animate-spin  animate-running " />
              </div>
              <span class="flex justify-end text-base sg-bold">winner</span>
            </div>
          </span>
        </div>
      </div>
    </div>
    <TheShowList :contestants="contestantData" :data="filteredShowList" />
  </div>
</template>

<style scoped>
.champ {
  view-transition-name: champ-name;
}
</style>
